/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/HumanId/LegacyId/Content"
  
}) {
let constantData = '(Old: '
let patientLegacyIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'legacy_id',
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, patientLegacyIdValueData, constantData1)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsNeutral700}
 marginLeft={4}
 data="'(Old: '"
 data="patient.legacy_id"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}